/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Tea_TypeInputs */

const vi_weighing_tea_type = /** @type {(inputs: Weighing_Tea_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại chè`)
};

/**

* @param {Weighing_Tea_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_tea_type = /** @type {((inputs?: Weighing_Tea_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Tea_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_tea_type(inputs)
});